import styled from 'styled-components';

export const Container = styled.div`
  background-color: ${({ theme }) => theme.colors.gray8};

  & > header {
    background-color: ${({ theme }) => theme.colors.white};
    padding: 1.5rem;
    border-radius: 0.25rem;
    margin: 0 auto 1rem;

    & > .title {
      font-size: 1.625rem;
      font-weight: 700;
    }
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
    width: auto;
    display: flex;
    flex-direction: column;
    align-items: center;
    & > header {
      margin: 5rem auto 1rem;
    }
  }
`;

export const OrdersHeader = styled.header`
  display: flex;
  flex-direction: column;
  margin: 1rem auto;

  @media (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
    margin: 1rem auto 1.5rem auto;
    padding: 0;
  }

  & > .title {
    font-size: 1.625rem;
    font-weight: 700;
    margin-bottom: 1.25rem;
  }

  & > .subtitle {
    font-size: 0.875rem;
    color: ${({ theme }) => theme.colors.grayDark2};
  }
`;

export const BlueFontRowActionContainer = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 0;

  span.hefesto-button__label {
    color: #244577;
  }
`;
